export default class ComplementsFinalSummary extends HTMLElement {

    constructor() {
        super();
        this.complements = JSON.parse(this.getAttribute('complements'));
        this.texts = JSON.parse(this.getAttribute('texts'));
        this.stylesheet = this.getAttribute('stylesheet');
    }

    connectedCallback() {
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const template = document.querySelector('#complements-final-summary');
        this.instance = template.content.cloneNode(true);
        this._createList(this.instance);
        this.instance.querySelector('[name="complement-summary-title"]').innerHTML = this.texts.titulo;
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        this._shadowRoot.appendChild(this.instance);

    }


    _createList(instance)
    {
        let list = instance.querySelector('.complements-list');
        let complementsList = list.querySelector('.complements-items');
        let item = document.querySelector('#complement');
        for (let complement of this.complements) {
            let day = complement.numDays === "1" ? this.texts.dia : this.texts.dias;
            let complementElement =  item.content.cloneNode(true);
            complementElement.querySelector('[name="complement-days"]').innerHTML = complement.numDays + " " + day
            complementElement.querySelector('[name="complement-name"]').innerHTML = complement.title;
            complementElement.querySelector('[name="complement-people"]').innerHTML = complement.people;
            complementElement.querySelector('[name="complement-people-text"]').innerHTML = complement.people === "1" ? this.texts.persona : this.texts.personas;
            complementElement.querySelector('[name="complement-amount"]').innerHTML = complement.pvp + "€";
            complementElement.querySelector('[name="complement-people-suffix"]').innerHTML = this.texts.euros_pers;
            complementsList.appendChild(complementElement);
         }
    }
}